// These functions are a companion to GridGeometry objects used to help with
// implementing grids where some cells are grouped together (e.g. abstract art).
// groupGrid is a 2D array of arbitrary values, giving the group value of each
// cell. Group values are arbitrary, with same values meaning same group. The
// two special values are anything falsy, which means the cell is not in the
// grid at all, and the number 1, which means the cell is its own group.

// TODO: Maybe object mapping cells to groups is better than a 2D array for
// other geometries?

// Get the group value of a cell. All falsy values and outside cells are 0.
const indexGroup = function(geom, groupGrid, cell) {
	if (!geom.isCellInGrid(cell[0], cell[1])) {
		return 0;
	}
	const groupRow = groupGrid[cell[1]];
	return (groupRow && groupRow[cell[0]]) || 0;
};

// Given an edge and a cell bordering it, get the other cell.
const getOtherCell = function(geom, edge, cell) {
	const cs = geom.getEdgeCells(edge[0], edge[1], edge[2]);
	return cs[0][0] === cell[0] && cs[0][1] === cell[1] ? cs[1] : cs[0];
};

// Get an array of edges giving all the boundaries to draw in a group grid.
const getAllBoundaries = function(geom, groupGrid) {
	return geom.getAllEdges().filter(edge => {
		const [c1, c2] = geom.getEdgeCells(edge[0], edge[1], edge[2]);
		const c1Group = indexGroup(geom, groupGrid, c1);
		const c2Group = indexGroup(geom, groupGrid, c2);
		return c1Group !== c2Group || c1Group === 1;
	});
};

// Get an array of edges giving the boundaries of the group containing the
// given cell in no particular order.
const getGroupBoundary = function(geom, groupGrid, startCell) {
	const cellGroup = indexGroup(geom, groupGrid, startCell);
	if (!cellGroup) {
		return [];
	} else if (cellGroup === 1) {
		return geom.getCellEdges(startCell[0], startCell[1]);
	} else {
		const cellsInGroup = new Set();
		cellsInGroup.add(startCell.join(","));
		const boundaries = [];
		const cellsToCheck = [startCell];
		while (cellsToCheck.length) {
			const cell = cellsToCheck.pop();
			geom.getCellEdges(cell[0], cell[1]).forEach(edge => {
				const otherCell = getOtherCell(geom, edge, cell);
				if (cellsInGroup.has(otherCell.join(","))) {
					// Do nothing; we already handled this one
				} else if (cellGroup === indexGroup(geom, groupGrid, otherCell)) {
					cellsInGroup.add(otherCell.join(","));
					cellsToCheck.push(otherCell);
				} else {
					boundaries.push(edge);
				}
			});
		}
		return boundaries;
	}
};

module.exports = {
	getAllBoundaries,
	getGroupBoundary,
};
